export const CONTRACT_TYPE_OPTIONS = [
    {
        value: 'FFP',
        label: 'FFP',
        description: 'Firm Fixed Price'
    },
    {
        value: 'T&M',
        label: 'T&M',
        description: 'Time & Materials'
    },
    {
        value: 'CPFF',
        label: 'CPFF',
        description: 'Cost Plus Fixed Fee'
    },
    {
        value: 'CPIF',
        label: 'CPIF',
        description: 'Cost Plus Incentive Fee'
    },
    {
        value: 'CPAF',
        label: 'CPAF',
        description: 'Cost Plus Award Fee'
    },
    {
        value: 'LH',
        label: 'Labor Hour',
        description: 'Labor Hour'
    },
    {
        value: 'HYBRID',
        label: 'Hybrid',
        description: 'Mixed contract types (e.g. FFP + T&M)'
    },
    {
        value: 'IDIQ',
        label: 'IDIQ',
        description: 'Indefinite Delivery / Indefinite Quantity'
    }
];
export const VEHICLE_OPTIONS = [
    {
        value: 'gsa_mas',
        label: 'GSA MAS',
        description: 'Multiple Award Schedule (formerly Schedule 70)'
    },
    {
        value: 'sewp_v',
        label: 'SEWP V',
        description: 'Solutions for Enterprise-Wide Procurement'
    },
    {
        value: 'cio_sp3',
        label: 'CIO-SP3',
        description: 'Chief Information Officer – Solutions and Partners 3'
    },
    {
        value: 'alliant_2',
        label: 'Alliant 2',
        description: 'IT solutions and services'
    },
    {
        value: 'oasis_plus',
        label: 'OASIS+',
        description: 'One Acquisition Solution for Integrated Services'
    },
    {
        value: '8a_stars_iii',
        label: '8(a) STARS III',
        description: 'SBA 8(a) Small Business'
    },
    {
        value: 'vets_2',
        label: 'VETS 2',
        description: 'SDVOSB GWAC'
    },
    {
        value: 'polaris',
        label: 'Polaris',
        description: 'Small Business IT GWAC'
    },
    {
        value: 'ites_3s',
        label: 'ITES-3S',
        description: 'Army IT services'
    },
    {
        value: 'taps',
        label: 'T4 APSS',
        description: 'DHS IT professional services'
    },
    {
        value: 'open_market',
        label: 'Open Market',
        description: 'Full and open competition'
    },
    {
        value: 'other',
        label: 'Other',
        description: 'Other contract vehicle'
    }
];
export const SET_ASIDE_OPTIONS = [
    {
        value: 'unrestricted',
        label: 'Unrestricted',
        description: 'Full and open competition'
    },
    {
        value: 'small_business',
        label: 'Small Business',
        description: 'Total small business set-aside'
    },
    {
        value: 'sdvosb',
        label: 'SDVOSB',
        description: 'Service-Disabled Veteran-Owned Small Business'
    },
    {
        value: 'vosb',
        label: 'VOSB',
        description: 'Veteran-Owned Small Business'
    },
    {
        value: 'wosb',
        label: 'WOSB',
        description: 'Women-Owned Small Business'
    },
    {
        value: 'edwosb',
        label: 'EDWOSB',
        description: 'Economically Disadvantaged WOSB'
    },
    {
        value: 'hubzone',
        label: 'HUBZone',
        description: 'Historically Underutilized Business Zone'
    },
    {
        value: '8a',
        label: '8(a)',
        description: 'SBA 8(a) Business Development Program'
    },
    {
        value: 'sdb',
        label: 'SDB',
        description: 'Small Disadvantaged Business'
    }
];
// NAICS codes moved to naicsCodes.ts (comprehensive ~120 code list).
// Major federal agencies. A full list would come from SAM.gov.
export const AGENCY_OPTIONS = [
    {
        value: 'Department of Defense',
        label: 'DoD',
        description: 'Department of Defense'
    },
    {
        value: 'Department of Veterans Affairs',
        label: 'VA',
        description: 'Department of Veterans Affairs'
    },
    {
        value: 'Department of Homeland Security',
        label: 'DHS',
        description: 'Department of Homeland Security'
    },
    {
        value: 'Department of Health and Human Services',
        label: 'HHS',
        description: 'Department of Health and Human Services'
    },
    {
        value: 'Department of the Treasury',
        label: 'Treasury',
        description: 'Department of the Treasury'
    },
    {
        value: 'Department of Justice',
        label: 'DOJ',
        description: 'Department of Justice'
    },
    {
        value: 'Department of State',
        label: 'State',
        description: 'Department of State'
    },
    {
        value: 'Department of Energy',
        label: 'DOE',
        description: 'Department of Energy'
    },
    {
        value: 'Department of the Interior',
        label: 'DOI',
        description: 'Department of the Interior'
    },
    {
        value: 'Department of Agriculture',
        label: 'USDA',
        description: 'Department of Agriculture'
    },
    {
        value: 'Department of Commerce',
        label: 'Commerce',
        description: 'Department of Commerce'
    },
    {
        value: 'Department of Labor',
        label: 'DOL',
        description: 'Department of Labor'
    },
    {
        value: 'Department of Transportation',
        label: 'DOT',
        description: 'Department of Transportation'
    },
    {
        value: 'Department of Education',
        label: 'ED',
        description: 'Department of Education'
    },
    {
        value: 'General Services Administration',
        label: 'GSA',
        description: 'General Services Administration'
    },
    {
        value: 'National Aeronautics and Space Administration',
        label: 'NASA',
        description: 'NASA'
    },
    {
        value: 'Environmental Protection Agency',
        label: 'EPA',
        description: 'Environmental Protection Agency'
    },
    {
        value: 'Social Security Administration',
        label: 'SSA',
        description: 'Social Security Administration'
    },
    {
        value: 'Small Business Administration',
        label: 'SBA',
        description: 'Small Business Administration'
    },
    {
        value: 'Office of Personnel Management',
        label: 'OPM',
        description: 'Office of Personnel Management'
    },
    {
        value: 'Intelligence Community',
        label: 'IC',
        description: 'Intelligence Community'
    }
];
